import React from 'react';
import { Button } from '@mui/material';
import { Icon } from '@iconify/react';

const AssignButton = ({ onClick, size = 'small', children, type = 'assign', disabled = false, label }) => {
  let icon = 'mdi:account-check-outline';
  let bgColor = '#e3f2fd';
  let color = '#1976d2';
  let hoverBg = '#5a9cdf';
  let text = label || children || 'Assign';

  if (type === 'add') {
    icon = 'mdi:plus-circle-outline';
    bgColor = '#e8f5e9';
    color = '#2e7d32';
    hoverBg = '#4f8551';
    text = label || children || 'Add Lead';
  }
  return (
    <Button
      size={size}
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: bgColor,
        color: color,
        borderColor: color,
        boxShadow: 'none',
        px: 2,
        '&:hover': {
          backgroundColor: hoverBg,
          color: '#fff',
        },
      }}
    >
      <Icon icon="mdi:account-check-outline" width="18" height="18" style={{ marginRight: '4px' }} />
      {text}
    </Button>
  );
};

export default AssignButton;
